import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as fragments from '../fragments'

const DOC = gql`
  ${fragments.connectorDefinition.DOC}
  mutation UpdateIntegrationConnectorDefinition(
    $tenantId: ID!
    $zoneId: ID!
    $id: ID!
    $updates: IntgConnectorDefinitionUpdates!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        updateIntgConnectorDefinition(id: $id, updates: $updates) {
          ...FragmentIntegrationConnectorDefinition
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.nonNull(
  graphql.transformers.OUT.select<
    graphql.schema.UpdateIntegrationConnectorDefinitionMutation,
    ents.core.integrations.Connector.Definition,
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'updateIntgConnectorDefinition',
        fragments.connectorDefinition.TRANSFORMER,
      ),
    ),
  ),
)

export const execute = graphql.createExecutor<
  graphql.schema.UpdateIntegrationConnectorDefinitionMutation,
  ents.core.integrations.Connector.Definition,
  graphql.schema.UpdateIntegrationConnectorDefinitionMutationVariables
>({ query: DOC, transformer: TRANSFORMER })
